/* @ngInject */
function rollbarService (CONSTANTS, $rootScope, Rollbar) {
  // dont send any log if http status code matches one of these

  const configParams = {
    accessToken: CONSTANTS.ROLLBAR_API_KEY,
    captureUncaught: false,
    captureUnhandledRejections: false,
    enable: CONSTANTS.ENVIRONMENT === 'qa' || CONSTANTS.ENVIRONMENT === 'production',
    payload: {
      environment: CONSTANTS.ENVIRONMENT,
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: '{{ROLLBAR_CODE_VERSION}}'
        }
      }
    }
  }

  const EXCLUDED_PATTERNS = [
    'unauthorized',
    'authentication_failed'
  ]

  /**
   * Validate if data should be sent to Rollbar
   * @param {*} data - Error data to validate
   * @returns {boolean} - true if data should be sent to Rollbar, false otherwise
   */
  function validateData (data) {
    if (!data || typeof data !== 'object') return true

    const checkFields = [data.data, data.code].filter(Boolean)
    if (checkFields.length === 0) return true

    return !EXCLUDED_PATTERNS.some(pattern =>
      checkFields.some(field =>
        String(field).toLowerCase().includes(pattern)
      )
    )
  }

  const api = {
    init,
    critical,
    error,
    warning,
    info,
    debug
  }

  return api

  function _mapDataPayload (data) {
    const obj = {}

    if (!data) {
      return obj
    }

    Object.keys(data).forEach(key => {
      if (data[key] === undefined || data[key] === null) {
        obj[key] = 'Value undefined/null'
      } else {
        obj[key] = data[key]
      }
    })

    return obj
  }

  function init () {
    if ($rootScope.oUser && $rootScope.oUser.id) {
      configParams.payload.person = {
        id: $rootScope.oUser.id,
        customerCompanyId: $rootScope.oUser.customerCompanyId,
        email: $rootScope.oUser.email,
        username: $rootScope.oUser.email
      }
    }

    if (configParams.enable) {
      Rollbar.init(configParams)
    }
  }

  // methods are set from highest priority to lowest priority
  function critical (e, data) {
    if (!validateData(data)) return
    if (!configParams.enable) return
    Rollbar.critical(e, _mapDataPayload(data))
  }

  function error (e, data) {
    if (!validateData(data)) return
    if (!configParams.enable) return
    Rollbar.error(e, _mapDataPayload(data))
  }

  function warning (e, data) {
    if (!validateData(data)) return
    if (!configParams.enable) return
    Rollbar.warning(e, _mapDataPayload(data))
  }

  function info (e, data) {
    if (!validateData(data)) return
    if (!configParams.enable) return
    Rollbar.info(e, _mapDataPayload(data))
  }

  function debug (e, data) {
    if (!validateData(data)) return
    if (!configParams.enable) return
    Rollbar.debug(e, _mapDataPayload(data))
  }
}

export { rollbarService }
